import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-913e9f4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cr-spinner" }


export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerComponent',
  props: {
  text: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_progress_circular, { indeterminate: "" }),
    _createTextVNode(" " + _toDisplayString(props.text), 1 /* TEXT */)
  ]))
}
}

})